import { classNames } from 'shared/lib/utils/classNames';

import cls from './IconWrapper.module.scss';

interface IconWrapperProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
}

/**
 * Компонент-обертка для иконок, которая приводит width и height к базовым размерам из Figma
 */
export const IconWrapper = (props: IconWrapperProps) => {
  const { className, icon, ...otherProps } = props;
  const IconNode = icon;

  return (
    <IconNode
      {...otherProps}
      className={classNames(cls.IconWrapper, {}, [className])}
    />
  );
};
